//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ATextblock from "../../../components/ATextblock.vue";
import ImageComponent from "../../../components/ImageComponent.vue";

export default {
  name: "NewDesignBlogPost",
  components: { ImageComponent, ATextblock },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      scrollTriggerInstance: null,
      sectionTriggers: [],
    };
  },
  computed: {
    heroBlock() {
      return {
        hidden: this.data.attributes.hidden || false,
        pretitle:
          this.data.attributes.hero && this.data.attributes.hero.pretitle
            ? this.data.attributes.hero.pretitle
            : "",
        title: this.data.attributes.headline || "",
        text: this.data.attributes.page_description || "",
        variant:
          this.data.attributes.hero && this.data.attributes.hero.variant
            ? this.data.attributes.hero.variant
            : "primary",
        button:
          this.data.attributes.hero && this.data.attributes.hero.button
            ? this.data.attributes.hero.button
            : null,
      };
    },
    tableOfContents() {
      // Generate table of contents directly from content blocks
      return this.data.attributes.content.map((block, index) => {
        // Extract title based on available properties
        let title = `Section ${index + 1}`;

        if (block.headline) {
          title = block.headline;
        } else if (block.title) {
          title = block.title;
        } else if (block.body) {
          // Use body content, strip HTML tags and limit length
          const strippedBody = block.body.replace(/<[^>]*>/g, "").trim();
          title =
            strippedBody.length > 50
              ? strippedBody.substring(0, 50) + "..."
              : strippedBody;
        }

        return {
          title,
          id: `section-${index}`,
        };
      });
    },
    allRelatedPosts() {
      // Mix related_posts and blog_posts into a single array, removing duplicates and current post
      const posts = [];
      const seenIds = new Set();
      const currentPostId = this.data.id;

      // Add related_posts if they exist
      if (
        this.data.attributes.related_posts &&
        this.data.attributes.related_posts.data &&
        this.data.attributes.related_posts.data.length > 0
      ) {
        this.data.attributes.related_posts.data.forEach((post) => {
          if (!seenIds.has(post.id) && post.id !== currentPostId) {
            seenIds.add(post.id);
            posts.push(post);
          }
        });
      }

      // Add blog_posts if they exist (skip duplicates and current post)
      if (
        this.data.attributes.blog_posts &&
        this.data.attributes.blog_posts.data &&
        this.data.attributes.blog_posts.data.length > 0
      ) {
        this.data.attributes.blog_posts.data.forEach((post) => {
          if (!seenIds.has(post.id) && post.id !== currentPostId) {
            seenIds.add(post.id);
            posts.push(post);
          }
        });
      }

      return posts;
    },
    relatedPostsCardset() {
      // Transform related posts into cardset format
      const MAX_TEXT_LENGTH = 150;

      return {
        pretitle: this.data.attributes.tagline_related,
        title: this.data.attributes.title_related,
        text: this.data.attributes.text_related,
        hidden: false,
        cards: this.allRelatedPosts.map((post) => {
          const fullText =
            post.attributes.description_short || post.attributes.excerpt || "";
          let truncatedText = fullText;

          if (fullText.length > MAX_TEXT_LENGTH) {
            // Cut at the last complete word
            truncatedText = fullText.substring(0, MAX_TEXT_LENGTH);
            const lastSpaceIndex = truncatedText.lastIndexOf(" ");
            if (lastSpaceIndex > 0) {
              truncatedText = truncatedText.substring(0, lastSpaceIndex);
            }
            truncatedText = truncatedText.trim() + "...";
          }

          return {
            id: post.id,
            title: post.attributes.headline || post.attributes.title,
            text: truncatedText,
            icon: post.attributes.image || null,
            btn_label: "Mehr lesen",
            blog_post: {
              data: post,
            },
          };
        }),
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      // Only initialize on desktop (>= 1200px)
      if (window.innerWidth >= 1200) {
        this.initScrollTrigger();
      }
    });

    // Handle window resize
    this.handleResize = () => {
      if (window.innerWidth >= 1200 && !this.scrollTriggerInstance) {
        this.initScrollTrigger();
      } else if (window.innerWidth < 1200 && this.scrollTriggerInstance) {
        this.destroyScrollTrigger();
      }
    };
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    this.destroyScrollTrigger();
    if (this.handleResize) {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  methods: {
    initScrollTrigger() {
      if (
        process.client &&
        this.$refs.indexWrapper &&
        this.$refs.contentColumn &&
        this.$ScrollTrigger
      ) {
        const ScrollTrigger = this.$ScrollTrigger;

        // Pin the index sidebar
        this.scrollTriggerInstance = ScrollTrigger.create({
          trigger: this.$refs.contentSection,
          start: "top 125px",
          end: "bottom bottom-=50px",
          pin: this.$refs.indexWrapper,
          pinSpacing: false,
          anticipatePin: 1,
        });

        // Track active section while scrolling
        this.data.attributes.content.forEach((_block, index) => {
          const sectionEl = document.getElementById(`section-${index}`);

          if (sectionEl) {
            const trigger = ScrollTrigger.create({
              trigger: sectionEl,
              start: "top center",
              end: "bottom center",
              onEnter: () => {
                this.activeIndex = index;
              },
              onEnterBack: () => {
                this.activeIndex = index;
              },
            });

            this.sectionTriggers.push(trigger);
          }
        });
      }
    },
    destroyScrollTrigger() {
      // Clean up ScrollTrigger instances
      if (this.scrollTriggerInstance) {
        this.scrollTriggerInstance.kill();
        this.scrollTriggerInstance = null;
      }
      this.sectionTriggers.forEach((trigger) => trigger.kill());
      this.sectionTriggers = [];
    },
    scrollToSection(index) {
      const sectionEl = document.getElementById(`section-${index}`);
      if (sectionEl && this.$gsap) {
        this.$gsap.to(window, {
          duration: 0.8,
          scrollTo: {
            y: sectionEl,
            offsetY: 150,
          },
          ease: "power2.inOut",
        });
      }
    },
  },
};
